export enum ArtsaasErrorCode {
  INSUFFICIENT_DISK_SPACE = 1, // BRAK MIEJSCA NA DYSKU KLIENTA
  MEDIA_FILE_TOO_LARGE = 2,    // ZBYT DUŻY PLIK
  NOT_SUPERADMIN = 3           // USER NIE POSIADA PRAW SUPERADMINA
}
